import React, { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion';
import { IoIosArrowBack } from 'react-icons/io';

const Accordion5 = ({ type }) => {
    const [rotationState, setRotationState] = useState(false);

    const toggleRotation = () => {
        setRotationState(!rotationState);
    };

    const accordionTransitionDuration = 500; // Set the same duration as the accordion transition

    const accordionClass = () => {
        switch (type) {
            case 'rounded':
                return 'max-w-[500px] mx-auto border-accordionBorderColor  bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor rounded-2xl border-[4px] shadow-lg';
            case 'rectangle':
                return 'max-w-[500px] mx-auto border-accordionBorderColor rounded-none bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor border-[4px] shadow-lg';
            default:
                return '';
        }
    };

    return (
        <div className='mt-6  mx-auto px-4'>
            <Accordion
                className={accordionClass()}
                transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
            >
                <AccordionItem>
                    <AccordionHeader
                        className=' bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor items-center text-accordion_headerColor flex p-4 w-full justify-between rounded-2xl'
                        onClick={toggleRotation}
                    >
                        <IoIosArrowBack
                            className={`${rotationState ? 'rotate-90' : ''} text-2xl text-accordion_iconColor`}
                            style={{ transition: `transform 0.5s ease-in-out` }}
                        />
                        <h3 dir='rtl' className='text-2xl font-bold'>לחצו כאן להצטרפות</h3>
                    </AccordionHeader>

                    <AccordionBody>
                        <div dir='rtl' className='text-accordionTextColor text-right font-medium p-4  rounded-b-2xl'>
                            <div className='border-[1px] border-gray-800 my-6 mt-0' />

                            <div>

                                <p className='mt-2 font-bold text-2xl text-pink-200'>
                                    מנוי אישי
                                </p>
                                <p dir='rtl' className='text-sm'>
                                    בעיקר בבקרים / צהריים
                                </p>

                                <ul className=' mt-2'>
                                    <li className='list-disc text-lg mr-5 '>
                                        <p className='text-yellow-200 font-bold mb-2'>
                                            4 אימונים  - 440₪
                                        </p>
                                        <a href="" className='text-yellow-200 font-bold  bg-gradient-to-tr px-2 py-1 rounded-full from-black to-[#333] duration-300 hover:opacity-80'>
                                            לחצו כאן לרכישה
                                        </a>
                                    </li>
                                    <li className='list-disc text-lg mr-5 mt-6 '>
                                        <p className='text-yellow-200 font-bold mb-2'>
                                            6 אימונים  - 580₪
                                        </p>
                                        <a href="" className='text-yellow-200 font-bold  bg-gradient-to-tr px-2 py-1 rounded-full from-black to-[#333] duration-300 hover:opacity-80'>
                                            לחצו כאן לרכישה
                                        </a>
                                    </li>
                                    <li className='list-disc text-lg mr-5 mt-6 '>
                                        <p className='text-yellow-200 font-bold mb-2'>
                                            5 אימונים  - 660₪
                                        </p>
                                        <a href="" className='text-yellow-200 font-bold  bg-gradient-to-tr px-2 py-1 rounded-full from-black to-[#333] duration-300 hover:opacity-80'>
                                            לחצו כאן לרכישה
                                        </a>
                                    </li>

                                </ul>


                                <div className='border-[1px] border-gray-800 my-6' />

                                <p className='mt-2 font-bold text-2xl text-pink-200'>
                                    מנוי קבוצתי
                                </p>
                                {/* <p dir='rtl' className='text-sm'>
                                    בעיקר בבקרים / צהריים
                                </p> */}

                                <ul className=' mt-2'>
                                    <li className='list-disc text-lg mr-5  mt-2'>
                                        <p className='text-yellow-200 font-bold mb-2'>
                                            4 אימונים  - 260₪
                                        </p>
                                        <p dir='rtl' className='text-sm mb-3'>
                                            פעם בשבוע
                                        </p>
                                        <a href="" className='text-yellow-200 font-bold  bg-gradient-to-tr px-2 py-1 rounded-full from-black to-[#333] duration-300 hover:opacity-80'>
                                            לחצו כאן לרכישה
                                        </a>
                                    </li>
                                    <li className='list-disc text-lg mr-5 mt-6 '>
                                        <p className='text-yellow-200 font-bold mb-2'>
                                            8 אימונים  - 470₪
                                        </p>
                                        <p dir='rtl' className='text-sm mb-3'>
                                            פעמיים בשבוע
                                        </p>
                                        <a href="" className='text-yellow-200 font-bold  bg-gradient-to-tr px-2 py-1 rounded-full from-black to-[#333] duration-300 hover:opacity-80'>
                                            לחצו כאן לרכישה
                                        </a>
                                    </li>
                                    <li className='list-disc text-lg mr-5   mt-6'>
                                        <p className='text-yellow-200 font-bold mb-2'>
                                            12 אימונים  - 600₪
                                        </p>
                                        <p dir='rtl' className='text-sm mb-3'>
                                            שלוש פעמים בשבוע
                                        </p>
                                        <a href="" className='text-yellow-200 font-bold  bg-gradient-to-tr px-2 py-1 rounded-full from-black to-[#333] duration-300 hover:opacity-80'>
                                            לחצו כאן לרכישה
                                        </a>
                                    </li>


                                </ul>


                                <div className='border-[1px] border-gray-800 my-6' />
                            </div>
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default Accordion5;
